import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionUnderstanding/SectionUnderstanding.module.scss';

const cn = classNames.bind(styles);

const SectionUnderstanding = (): ReactElement => {
  return (
    <section className={cn('understanding')}>
      <div className={cn('container')}>

        <h2 className={cn('understanding__heading')}>
          Why Understanding Demurrage and Detention is Vital
        </h2>

        <div className={cn('understanding__description')}>
          <p className={cn('understanding__paragraph')}>
            The impact of detention and demurrage fees goes far beyond just increased costs. While they
            might seem insignificant at first, these charges can quickly add up, eating into your profits.
            According to the Demurrage and Detention Report, factors like blank sailings (cancellation of
            scheduled shipping voyages) and container shortages, exacerbated by geopolitical tensions or
            other supply chain disruptions, significantly impact Demurrage and Detention charges.
          </p>
          <p className={cn('understanding__paragraph')}>
            For example, if the demurrage rate for a 20 ft container for the first ten days is $60, and the
            charge after is $12,000 - the total would reach $18,000, which increases significantly when
            multiplied across several containers and shipments. This example illustrates how quickly
            demurrage costs can escalate if containers are not cleared from the port in a timely manner.
          </p>
        </div>

        <div className={cn('understanding__table-container')}>
          <table className={cn('understanding__table')}>
            <caption className={cn('understanding__table-title')}>
              Top 10 most expensive ports in terms of Demurrage and Detention charges (2024)
            </caption>
            <thead>
              <tr>
                <th className={cn('understanding__table-head')}>Ranking in 2023</th>
                <th className={cn('understanding__table-head')}>Port location</th>
                <th className={cn('understanding__table-head')}>Average D&D charges after 14 days for standard containers in USD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={cn('understanding__table-data')}>1</td>
                <td className={cn('understanding__table-data')}>New York</td>
                <td className={cn('understanding__table-data')}>$2,478</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>2</td>
                <td className={cn('understanding__table-data')}>Oakland</td>
                <td className={cn('understanding__table-data')}>$2,325</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>3</td>
                <td className={cn('understanding__table-data')}>Los Angeles</td>
                <td className={cn('understanding__table-data')}>$2,069</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>4</td>
                <td className={cn('understanding__table-data')}>Savannah</td>
                <td className={cn('understanding__table-data')}>$2,014</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>5</td>
                <td className={cn('understanding__table-data')}>Long Beach</td>
                <td className={cn('understanding__table-data')}>$1,973</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>6</td>
                <td className={cn('understanding__table-data')}>Houston</td>
                <td className={cn('understanding__table-data')}>$1,919</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>7</td>
                <td className={cn('understanding__table-data')}>Vancouver</td>
                <td className={cn('understanding__table-data')}>$1,816</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>8</td>
                <td className={cn('understanding__table-data')}>Hong Kong</td>
                <td className={cn('understanding__table-data')}>$691</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>9</td>
                <td className={cn('understanding__table-data')}>Chennai</td>
                <td className={cn('understanding__table-data')}>$585</td>
              </tr>
              <tr>
                <td className={cn('understanding__table-data')}>10</td>
                <td className={cn('understanding__table-data')}>Hamburg</td>
                <td className={cn('understanding__table-data')}>$584</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={cn('understanding__summary')}>
          <p className={cn('understanding__paragraph')}>
            This ranking is based on data from major ports around the world.
          </p>

          <p className={cn('understanding__paragraph')}>
            Beyond the financial strain, these delays disrupt the smooth operation of the supply chain,
            affecting your relationship with clients who depend on timely deliveries. Demurrage costs are a
            significant factor in overall shipping expenses. A deep understanding of what causes these
            fees and how to minimise them can help you avoid these issues and maintain a healthy
            business.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionUnderstanding;